import request from '../helpers/request'

export default {
  postUserData: async (formData) => {
    const { data } = await request.post('/cabinet/profile/new-personal-data/', formData)

    return data
  },
  postUserPhoto: async (photo) => {
    const headers = {
      'Content-Type': 'multipart/form-data'
    }

    const formData = new FormData()

    formData.append('photo', photo)

    const { data } = await request.post('/cabinet/profile/new-photo/', formData, { headers })

    return data
  },
  deleteUserPhoto: async () => {
    const { data } = await request.post('/cabinet/profile/delete-new-photo/')

    return data
  },
  sendBill: async ({ orderId, email }) => {
    const { data } = await request.post('/cabinet/order/send-email-invoice/', null, {
      params: {
        orderId,
        email
      }
    })

    return data
  },
  getWarrantyCard: async (params) => {
    const { data } = await request.get('/cabinet/order/get-order-warranty-card/', { params, responseType: 'blob' })

    return data
  },
  getOrders: async (params) => {
    const { data } = await request.get('/cabinet/order/history/', { params })

    return data
  },
  getWishlist: async (params) => {
    const { data } = await request.get('/cabinet/wishlist/get-wishlist/', { params })

    return data
  },
  changeWishlistStatus: async (url) => {
    const { data } = await request.get(url)

    return data
  },
  getWaitlist: async (params) => {
    const { data } = await request.get('/cabinet/waitlist/get-waitlist/', { params })

    return data
  },
  changeWaitlistStatus: async (formData) => {
    const { data } = await request.post('/cabinet/waitlist/add-or-delete/', formData)

    return data
  },
  getViewedProducts: async (params) => {
    const { data } = await request.get('/cabinet/viewed-products/get-viewed-products/', { params })

    return data
  },
  getPromotions: async () => {
    const { data } = await request.get('/cabinet/marketing/personal-promotions/')

    return data
  },
  getWorkshop: async () => {
    const { data } = await request.get('/cabinet/workshop/get-purchased-products/')

    return data
  },
  getCommunications: async () => {
    try {
      const { data } = await request.get('/cabinet/profile/get-preferred-communication/')

      return data
    } catch (e) {
      throw e
    }
  },
  setCommunications: async (formData) => {
    try {
      const { data } = await request.post('/cabinet/profile/set-preferred-communication/', formData)

      return data
    } catch (e) {
      throw e
    }
  }
}
